import { cva, type VariantProps } from "class-variance-authority";

const base = [
  "SelectItem",
  "w-full flex items-center",
  "peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
  "font-medium leading-none",
  ,
  "hover:bg-urbix-gray-200",
  "pl-[0.5rem]",
];

export const selectItemVariants = cva(base, {
  variants: {
    size: {
      sm: "text-[0.75rem] min-h-[2rem]",
      md: "text-[0.875rem] min-h-[2.25rem]",
    },
    disabled: {
      true: "cursor-not-allowed opacity-50 bg-red",
      false: "*:cursor-pointer cursor-pointer",
    },
  },
  defaultVariants: {
    size: "md",
    disabled: false,
  },
});

export type SelectItemVariantsProps = VariantProps<typeof selectItemVariants>;

export const getItemHeight = (size: SelectItemVariantsProps["size"]) => {
  return size === "sm" ? 32 : 36;
};
